import { render, staticRenderFns } from "./ChallengeFaqs.vue?vue&type=template&id=1d58f18a"
import script from "./ChallengeFaqs.vue?vue&type=script&lang=ts"
export * from "./ChallengeFaqs.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeFaqs.vue?vue&type=style&index=0&id=1d58f18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports